import "./style.scss";
import { FC } from "react";

interface AOPFieldVisibilityToggleProps {
  visible: boolean;
  onChange: (visible: boolean) => void;
  ariaLabel?: string;
  disabled?: boolean;
  letter?: string;
}

const AOPFieldVisibilityToggle: FC<AOPFieldVisibilityToggleProps> = ({
  visible,
  onChange,
  ariaLabel,
  disabled = false,
  letter = "A",
}) => (
  <button
    type="button"
    className={`aop-field-visibility-toggle ${visible ? "is-visible" : "is-hidden"}`}
    aria-label={ariaLabel ?? (visible ? "Hide field in document" : "Show field in document")}
    aria-pressed={visible}
    disabled={disabled}
    onClick={() => {
      if (disabled) return;
      onChange(!visible);
    }}
  >
    {letter}
  </button>
);

export default AOPFieldVisibilityToggle;
